import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4963bd24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom" }
const _hoisted_2 = { class: "d-flex header" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-right" }, null, -1))
const _hoisted_5 = { class: "table" }
const _hoisted_6 = ["onClick", "title"]
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Guardar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_center = _resolveComponent("center")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("info_tmoa.title_info")), 1)
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_table, {
            data: _ctx.infoTmoaCopy,
            border: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "type",
                width: "160"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: _ctx.$t('label.name'),
                width: "250"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "value",
                label: _ctx.$t('label.value'),
                width: "250"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "description",
                label: _ctx.$t('label.description'),
                class: "table-description cell"
              }, null, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                label: "Editar",
                class: "table-edit",
                width: "120"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createElementVNode("em", {
                        class: "el-icon el-icon-edit fas",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.editTmoa(row)),
                        title: _ctx.$t('btn.edit')
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.openEditModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openEditModal) = $event)),
      title: "Editar matriz de agua",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_el_button, { onClick: _ctx.closeModal }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.saveTmoa
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "editForm",
          model: _ctx.editedTmoa,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "Nombre" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.editedTmoa.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editedTmoa.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Descripción" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editedTmoa.description) = $event)),
                  class: "el-textarea",
                  maxlength: "250"
                }, null, 512), [
                  [_vModelText, _ctx.editedTmoa.description]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}